import { render } from "./ShopFooter.vue?vue&type=template&id=f2486f5e"
import script from "./ShopFooter.vue?vue&type=script&lang=js"
export * from "./ShopFooter.vue?vue&type=script&lang=js"

import "./ShopFooter.vue?vue&type=style&index=0&id=f2486f5e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__